import $ from 'jquery';

class StateSelect {
    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('select.variable-state-select, select.variable-page-select').change((e) => {
            const stateUrl = $(e.currentTarget).val();
            if (stateUrl !== '') {
                window.location = stateUrl;
            }
        });

        $('.variable-state-toggle .before button').click((e) => {
            let parent = $(e.currentTarget).closest('.variable-state-toggle');
            $(parent).find('.before').addClass('d-none');
            $(parent).find('.after').removeClass('d-none');
        });

        $('select.variable-sota-state-select').change((e) => {
            const sotaStateBaseUrl = '/research/sota/city-rankings/states/';
            const sotaState = $(e.currentTarget).val();
            if (sotaState !== '') {
                let sotaStateRedirectUrl = sotaStateBaseUrl + sotaState;
                $('.sota-state-redirect').attr('href', sotaStateRedirectUrl);
            }
        });

        $('.tabs-dropdown-select select').change((e) => {
            const id = $(e.currentTarget).val();
            $(`#${id}`).siblings().removeClass('active show');
            $(`#${id}`).addClass('active show');
        });
    }
}

export default StateSelect;
